import "./architecture.css";
// import IMAGES from "../../images/images";
import MainSlider from "../../components/mainslider/MainSlider";
import CardRow from "../../components/cardRow/CardRow";
import Footer from "../../components/footer/Footer";


export default function Architecture() {
    return (
        <div className="archi">
            <MainSlider />
            <CardRow />
            
            <Footer />
        </div>
    )
}
